"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchematicModelInstance = exports.MultiSheetSchematicModelSchema = exports.SchematicModelSchema = exports.SchematicModelMultiInstanceConfigurationSchema = exports.MultiInstanceDisplayModuleSchema = exports.SchematicModelInstanceConfigurationSchema = void 0;
const zod_1 = require("zod");
const Module_1 = require("./DrawingModels/Module");
const SchDrawing_1 = require("./DrawingModels/SchDrawing");
const ModelBase_1 = require("./ModelBase");
const SchematicModelPort_1 = require("./SchematicModelPort");
exports.SchematicModelInstanceConfigurationSchema = zod_1.z.object({
    instanceSheetIndex: zod_1.z.number(),
    instanceName: zod_1.z.string(),
    instanceId: zod_1.z.string(),
    sheetDisplayPath: zod_1.z.array(zod_1.z.string()).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
});
exports.MultiInstanceDisplayModuleSchema = Module_1.ModuleSchema.extend({});
exports.SchematicModelMultiInstanceConfigurationSchema = zod_1.z.object({
    instances: exports.SchematicModelInstanceConfigurationSchema.array(),
    multiInstanceModules: exports.MultiInstanceDisplayModuleSchema.array(),
});
exports.SchematicModelSchema = (0, ModelBase_1.ModelBaseSchema)(SchDrawing_1.SchDrawingSchema).extend({
    modelType: zod_1.z.literal('schematic'),
    sheetIndex: zod_1.z.number(),
    modules: Module_1.ModuleSchema.array(),
    ports: zod_1.z.record(zod_1.z.string(), SchematicModelPort_1.SchematicModelPortSchema).prefault({}),
    multiInstanceConfiguration: exports.SchematicModelMultiInstanceConfigurationSchema.optional(),
});
exports.MultiSheetSchematicModelSchema = exports.SchematicModelSchema.extend({
    multiInstanceConfiguration: exports.SchematicModelMultiInstanceConfigurationSchema,
});
class SchematicModelInstance extends ModelBase_1.ModelBaseInstance {
    constructor(context, opts) {
        super(context, {
            modelType: 'schematic',
            ...opts,
            metadata: {
                title: '',
                revision: '',
                company: '',
                date: '',
                ...(opts.metadata ?? {}),
            },
        });
        this.modules = [];
        this.ports = new Map();
        this.sheetIndex = opts.sheetIndex ?? 0;
        this.modules = Array.from(opts.modules ?? []).map((m) => new Module_1.ModuleInstance(context, m));
        this.ports = new Map(Object.entries(opts.ports ?? {}).map(([name, port]) => [name, new SchematicModelPort_1.SchematicModelPortInstance(context, port)]));
    }
    addModule(module) {
        this.modules.push(module instanceof Module_1.ModuleInstance ? module : new Module_1.ModuleInstance(this.context, module));
    }
    addPort(port) {
        this.ports.set(port.name, port instanceof SchematicModelPort_1.SchematicModelPortInstance ? port : new SchematicModelPort_1.SchematicModelPortInstance(this.context, port));
    }
    toJSON() {
        return {
            ...this.serializeModelBaseInstanceProps(),
            sheetIndex: this.sheetIndex,
            modules: this.modules.map((m) => m.toJSON()),
            ports: Object.fromEntries(Array.from(this.ports.entries()).map(([name, port]) => [name, port.toJSON()])),
        };
    }
}
exports.SchematicModelInstance = SchematicModelInstance;
//# sourceMappingURL=SchematicModel.js.map